import {ElementLinkUnderlineItem} from "./element-link-underline-item";

export class ElementLinkUnderline {
    constructor() {
        document.querySelectorAll('.js-linkNone:not(.is-handler)').forEach(el => {
            new ElementLinkUnderlineItem({el});
        });

        document.querySelectorAll('.footer_menu a:not(.is-handler)').forEach(el => {
            new ElementLinkUnderlineItem({el});
        });

        document.querySelectorAll('.socials a:not(.is-handler)').forEach(el => {
            new ElementLinkUnderlineItem({el});
        });

        document.querySelectorAll('.footer_socials a:not(.is-handler)').forEach(el => {
            new ElementLinkUnderlineItem({el});
        });
    }
}